import * as requests from './requests'
import constants from './constants'
import urls from './urls'

// Producto
export async function getProductosFiltered(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_PRODUCTOS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getProductos() {
  return requests.get(constants.API_URL_CATALOGO, urls.GET_PRODUCTOS).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function getProductoById(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_PRODUCTO_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateProducto(payload) {
  return requests
    .putForm(constants.API_URL_CATALOGO, urls.PUT_PRODUCTO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertProducto(payload) {
  return requests
    .postForm(constants.API_URL_CATALOGO, urls.POST_PRODUCTO_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteProducto(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_PRODUCTO_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function deleteProductoList(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.DELETE_PRODUCTOS_BY_IDS, payload)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getProductosOrdenarCategoriaByIdiomaId(idiomaId, categoriaId) {
  return requests
    .get(
      constants.API_URL_CATALOGO,
      `${urls.GET_PRODUCTOS_ORDENACION_CATEGORIA_BY_IDIOMA_ID}?catagoriaId=${categoriaId}&idiomaId=${idiomaId}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getProductoInfoDescarga(productoId) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_PRODUCTO_INFO_DESCARGA}?id=${productoId}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setGuardarOrdenacionProductos(idiomaId, payload) {
  return requests
    .patch(
      constants.API_URL_CATALOGO,
      `${urls.PATCH_PRODUCTOS_ORDENACION_CATEGORIA_GUARDAR_POSICIONES}/${idiomaId}`,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function patchProducto(id, payload) {
  return requests
    .jsonPatch(constants.API_URL_CATALOGO, `${urls.PATCH_PRODUCTO_UPDATE}/${id}`, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function cambiarCategoriaPersonalizadaProducto(payload) {
  return requests
    .patch(constants.API_URL_CATALOGO, urls.PATCH_CAMBIAR_CATEGORIA_PERSONALIZADA_PRODUCTO, payload)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Productos adicionales

export async function getProductosAdicionalesByIdiomaId(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_PRODUCTOS_ADICIONALES_BY_IDIOMA_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setGuardarOrdenacionProductosAdicionales(idiomaId, payload) {
  return requests
    .patch(
      constants.API_URL_CATALOGO,
      `${urls.PATCH_PRODUCTOS_ADICIONALES_GUARDAR_ORDENACION}/${idiomaId}`,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

// Biblioteca de precios producto

export async function updateProductosBibliotecaPrecios(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_PRODUCTOS_BIBILIOTECAPRECIOS_UPDATE, payload)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getRecuperarListaProductosEliminados(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.GET_RECUPERAR_LISTA_PRODUCTOS_ELIMINADOS, payload)
    .then(async response => {
      return { ok: response?.ok, data: await response?.json() }
    })
}

export async function setActivarProductosEliminados(payload) {
  return requests
    .patch(constants.API_URL_CATALOGO, urls.PATCH_ACTIVAR_PRODUCTOS_ELIMINADOS, payload)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function getPrecioProducto(productoId, quantity, idiomaId) {
  return requests
    .get(
      constants.API_URL_CATALOGO,
      `${urls.GET_PRECIO_PRODUCTO}?productoId=${productoId}&quantity=${quantity}&idiomaId=${idiomaId}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.text() }
    })
}

// Productos de avatares
export async function getProductosAvatares() {
  return requests
    .get(constants.API_URL_CATALOGO, urls.GET_PRODUCTOS_AVATARES)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Categoria

export async function getCategoriasFiltered(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.GET_CATEGORIAS_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getCategorias() {
  return requests.get(constants.API_URL_CATALOGO, urls.GET_CATEGORIAS).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function getCategoriasChilds() {
  return requests
    .get(constants.API_URL_CATALOGO, urls.GET_CATEGORIAS_CHILD)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getSubCategorias(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_SUBCATEGORIAS}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getCategoriaPersonalizados() {
  return requests
    .get(constants.API_URL_CATALOGO, urls.GET_CATEGORIA_PERSOALIZADOS)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getCategoriaById(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_CATEGORIA_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateCategoria(payload) {
  return requests
    .putForm(constants.API_URL_CATALOGO, urls.PUT_CATEGORIA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertCategoria(payload) {
  return requests
    .postForm(constants.API_URL_CATALOGO, urls.POST_CATEGORIA_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteCategoria(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_CATEGORIA_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function deleteCategoriaList(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.DELETE_CATEGORIAS_BY_IDS, payload)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateCategoriaPersonalizado(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_CATEGORIA_PERSONALIZADOS_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function removeCacheCategoria() {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_REMOVE_CACHE_CATEGORIA)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function limpiarCacheCategoriaIds(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.LIMPIAR_CACHE_CATEGORIA_IDS, payload)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Iva

export async function getIvas() {
  return requests.get(constants.API_URL_CATALOGO, urls.GET_IVAS).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function getIvaDescripciones() {
  return requests
    .get(constants.API_URL_CATALOGO, urls.GET_IVA_DESCRIPCIONES)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateIvaDescripciones(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_IVA_DESCRIPCIONES, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertIvaDescripciones(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_IVA_DESCRIPCIONES, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteIvaDescripciones(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_IVA_DESCRIPCIONES}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Mapa

export async function getMapas() {
  return requests.get(constants.API_URL_CATALOGO, urls.GET_MAPAS).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

// Url

export async function getUrls() {
  return requests.get(constants.API_URL_CATALOGO, urls.GET_URLS).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function getUrlsByCategoria(payload) {
  const { id, idiomaId } = payload
  const query = idiomaId ? `?idiomaId=${idiomaId}` : ''
  const response = await requests.get(
    constants.API_URL_CATALOGO,
    `${urls.GET_URLS_BY_CATEGORIA}/${id}${query}`,
  )
  return { ok: response.ok, data: await response.json() }
}

export async function getUrlsByCategoriaWithUrlGrupo(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_URLS_BY_CATEGORIA_WITH_URL_GRUPO}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getUrlsByUrlGrupo(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_URLS_BY_GRUPO}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getUrlsDeleted() {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_URLS_DELETED}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getUrlsFiltered(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.GET_URLS_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getUrlsFilteredReduced(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.GET_URLS_FILTERED_REDUCED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getUrlById(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_URL_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateUrl(payload) {
  return requests
    .putForm(constants.API_URL_CATALOGO, urls.PUT_URL_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertUrl(payload) {
  return requests
    .postForm(constants.API_URL_CATALOGO, urls.POST_URL_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteUrl(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_URL_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function deleteUrlList(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.DELETE_URLS_BY_IDS, payload)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function setMostrarCantidadUrl(urlId, activado) {
  return requests
    .put(
      constants.API_URL_CATALOGO,
      `${urls.SET_MOSTRARCANTIDAD_URL}/${urlId}?activado=${activado}`,
    )
    .then(response => {
      return { ok: response.ok, data: response.text() }
    })
}

export async function updateUrlCartel(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_URL_CARTEL_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function sortUrlsGrupoUrl(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_SORT_URLS_URL_GRUPO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function desasociarUrlUrlGrupo(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_DESASOCIAR_URLS_URL_GRUPO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function asociarUrlUrlGrupo(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_ASOCIAR_URLS_URL_GRUPO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function establecerNoGrupoUrlUrlGrupo(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_NOGRUPO_URLS_URL_GRUPO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function duplicarUrl(payload) {
  return requests.post(constants.API_URL_CATALOGO, urls.DUPLICAR_URL, payload).then(response => {
    return { ok: response.ok, data: response }
  })
}

export async function duplicarProductosUrl(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.DUPLICAR_PRODUCTOS_URL, payload)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function reactivarUrls(payload) {
  return requests.put(constants.API_URL_CATALOGO, urls.REACTIVAR_URLS, payload).then(response => {
    return { ok: response.ok, data: response }
  })
}

export async function getUrlActivadasNoTraducidas(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.GET_URLS_ACTIVADAS_NO_TRADUCIDAS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function cambiarCategoriaUrl(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.CAMBIAR_CATEGORIA_URL, payload)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function limpiarCacheUrl(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.LIMPIAR_CACHE_URL, payload)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Url Adicionales

export async function getUrlAdicionales(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_URLS_ADICIONALES}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateUrlsAdicionales(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_URLS_ADICIONALES_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Multimedia URL
export async function getAllMultimediaUrlByUrlId(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_ALL_MULTIMEDIA_BY_URL_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getMultimediaUrlFiltered(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_MULTIMEDIA_URL_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertMultimediaUrl(payload) {
  return requests
    .postForm(constants.API_URL_CATALOGO, urls.POST_MULTIMEDIA_URL_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateMultimediaUrl(payload) {
  return requests
    .putForm(constants.API_URL_CATALOGO, urls.PUT_MULTIMEDIA_URL, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteMultimediaUrl(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_MULTIMEDIA_URL}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function getAllUrlMultimediaByMultimediaIdAsync(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_URL_MULTIMEDIA_URL_BY_MULTIMEDIAID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertUrlMultimediaUrl(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_URL_MULTIMEDIA_URL_INSERT_MASIVO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateUrlMultimediaUrlMasivo(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_URL_MULTIMEDIA_URL_UPDATE_MASIVO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteUrlMultimediaUrl(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, urls.DELETE_URL_MULTIMEDIA_URL, payload)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function deleteUrlMultimediaUrlByMultimediaId(payload) {
  return requests
    .remove(
      constants.API_URL_CATALOGO,
      `${urls.DELETE_URL_MULTIMEDIA_URL_BY_MULTIMEDIA_ID}/${payload}`,
    )
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

// Url Foto
export async function getUrlsFotosByUrlId(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_URLS_FOTOS}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertUrlFoto(payload) {
  return requests
    .postForm(constants.API_URL_CATALOGO, urls.POST_URL_FOTO_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function updateUrlFoto({ file, id, idioma, grande }) {
  return requests
    .postForm(
      constants.API_URL_CATALOGO,
      `${urls.UPDATE_URL_FOTO_INSERT}/${id}/${idioma}?grande=${grande ?? false}`,
      file,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteUrlFoto(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_URL_FOTO_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateUrlsFotosSortItems(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_URLS_FOTOS_SORT_ITEMS_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Url Grupo

export async function getUrlGrupos(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_URL_GRUPOS_BY_TYPE}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getUrlGrupoById(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_URL_GRUPO_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateUrlGrupo(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_URL_GRUPO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertUrlGrupo(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_URL_GRUPO_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteUrlGrupo(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_URL_GRUPO_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Cartel

export async function getCarteles() {
  return requests.get(constants.API_URL_CATALOGO, urls.GET_CARTELES).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function getCartelById(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_CARTEL_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateCartel(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_CARTEL_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertCartel(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_CARTEL_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteCartel(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_CARTEL_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Fechas Senaladas

export async function getFechasSenaladas() {
  return requests
    .get(constants.API_URL_CATALOGO, urls.GET_FECHAS_SENALADAS)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateFechaSenalada(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_FECHA_SENALADA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteFechaSenalada(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_FECHA_SENALADA_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getFechaSenaladaById(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_FECHA_SENALADA_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertFechaSenalada(payload) {
  return requests
    .postForm(constants.API_URL_CATALOGO, urls.POST_FECHA_SENALADA_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateFechaSenaladaAll(payload) {
  return requests
    .putForm(constants.API_URL_CATALOGO, urls.PUT_FECHA_SENALADA_UPDATE_ALL, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Fechas Senaladas Url

export async function getFechasSenaladasUrlByFechaId(payload) {
  const { id, idiomaId } = payload
  const query = idiomaId ? `?idiomaId=${idiomaId}` : ''
  const response = await requests.get(
    constants.API_URL_CATALOGO,
    `${urls.GET_FECHAS_SENALADAS_URL_BY_ID}/${id}${query}`,
  )
  return { ok: response.ok, data: await response.json() }
}

export async function getFechasSenaladasUrlSortImagesByFechaId(payload) {
  const { id, idiomaId } = payload
  const query = idiomaId ? `?idiomaId=${idiomaId}` : ''
  const response = await requests.get(
    constants.API_URL_CATALOGO,
    `${urls.GET_FECHAS_SENALADAS_URL_SORT_IMAGES_BY_ID}/${id}${query}`,
  )
  return { ok: response.ok, data: await response.json() }
}

export async function insertFechaSenaladaUrl(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_FECHAS_SENALADAS_URL_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteFechaSenaladaUrl(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_FECHA_SENALADA_URL_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateFechaSenaladaUrl(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_FECHA_SENALADA_URL_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateFechaSenaladaUrlSortImages(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_FECHA_SENALADA_URL_SORT_IMAGES_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Etiquetas

export async function getEtiquetasByPadreId(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_ETIQUETAS_BY_PADREID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getEtiquetas() {
  return requests.get(constants.API_URL_CATALOGO, urls.GET_ETIQUETAS_ALL).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function deleteEtiqueta(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_ETIQUETA_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateEtiquetasSortItems(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_ETIQUETA_SORT_ITEMS_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getEtiquetaById(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_ETIQUETA_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateEtiqueta(payload) {
  return requests
    .putForm(constants.API_URL_CATALOGO, urls.PUT_ETIQUETA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertEtiqueta(payload) {
  return requests
    .postForm(constants.API_URL_CATALOGO, urls.POST_ETIQUETA_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function removeCacheEtiqueta() {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_REMOVE_CACHE_ETIQUETA)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Etiqueta Url

export async function insertEtiquetaUrl(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_ETIQUETA_URL_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getEtiquetasUrlByEtiquetaId(payload) {
  const { id, idiomaId } = payload
  const query = idiomaId ? `?idiomaId=${idiomaId}` : ''
  const response = await requests.get(
    constants.API_URL_CATALOGO,
    `${urls.GET_ETIQUETAS_URL_BY_ID}/${id}${query}`,
  )
  return { ok: response.ok, data: await response.json() }
}

export async function updateEtiquetaUrl(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_ETIQUETA_URL_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteEtiquetaUrl(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_ETIQUETA_URL_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateEtiquetaUrlSort(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_ETIQUETA_URL_SORT_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function bulkUpdateEtiquetaUrlOrder(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_ETIQUETA_URL_BULK_UPDATE_ORDER, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Articulos

export async function getArticulos() {
  return requests.get(constants.API_URL_CATALOGO, urls.GET_ARTICULOS).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function getArticulosFiltered(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.GET_ARTICULOS_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getArticulosVentas(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.GET_ARTICULOS_VENDIDOS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertArticulo(payload) {
  return requests
    .postForm(constants.API_URL_CATALOGO, urls.POST_ARTICULO_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateArticulo(payload) {
  return requests
    .putForm(constants.API_URL_CATALOGO, urls.PUT_ARTICULO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteArticulo(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_ARTICULO_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getArticuloById(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_ARTICULO_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getArticulosProdcutosByArticuloId(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_ARTICULOS_PRODUCTOS_BY_ARTICULO_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteArticuloProducto(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_ARTICULO_PRODUCTO_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function insertArticulosProductos(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_ARTICULOS_PRODUCTOS_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getArticulosFaltantes() {
  return requests
    .get(constants.API_URL_CATALOGO, urls.GET_ARTICULOS_FALTANTES)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateArticulosStock(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_ARTICULO_STOCK_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateArticuloUser(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_ARTICULO_USER, payload)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateArticuloUserMostrar(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_ARTICULO_USER_MOSTRAR, payload)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateArticuloAgotar(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_ARTICULO_AGOTAR, payload)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateArticuloStockAjuste(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_ARTICULO_STOCK_AJUSTE, payload)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

// Historial Stock

export async function getHistorialStocks(payload) {
  return requests
    .get(
      constants.API_URL_AGGREGATOR,
      `${urls.GET_HISTORIAL_STOCKS_TOP}/${payload.articuloId}/${payload.top}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertHistorialStock(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_HISTORIAL_STOCK_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateHistorialStock(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_HISTORIAL_STOCK_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteHistorialStock(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_HISTORIAL_STOCK_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Frutas

export async function getFrutas() {
  return requests.get(constants.API_URL_CATALOGO, urls.GET_FRUTAS_ALL).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function insertFruta(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_FRUTA_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateFruta(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_FRUTA_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteFruta(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_FRUTA_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getSumaCantidadProductoFrutas(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_GET_PRODUCTO_FRUTAS_SUMA_CANTIDAD, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Proveedores

export async function getProveedores() {
  return requests.get(constants.API_URL_CATALOGO, urls.GET_PROVEEDORES).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function insertProveedor(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_PROVEEDOR_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateProveedor(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_PROVEEDOR_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteProveedor(payload) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_PROVEEDOR_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getProveedorById(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_PROVEEDOR_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Producto Generico

export async function getProductosGenericos(deleted) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.PRODUCTO_GENERICO}?&deleted=${deleted}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertProductosGenericos(payload) {
  return requests
    .postForm(constants.API_URL_CATALOGO, urls.PRODUCTO_GENERICO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateProductosGenericos(payload) {
  return requests
    .putForm(constants.API_URL_CATALOGO, urls.PRODUCTO_GENERICO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteProductosGenericos(id) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.PRODUCTO_GENERICO}/${id}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getProductosGenericosById(id) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.PRODUCTO_GENERICO}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Producto Generico Boceto

export async function getProductosGenericosBocetos(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.GET_PRODUCTO_GENERICO_BOCETO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertProductosGenericosBocetos(payload) {
  return requests
    .postForm(constants.API_URL_CATALOGO, urls.PRODUCTO_GENERICO_BOCETO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateProductosGenericosBocetos(payload) {
  return requests
    .putForm(constants.API_URL_CATALOGO, urls.PRODUCTO_GENERICO_BOCETO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateProductosGenericosBocetosPosicion(payload) {
  return requests
    .put(constants.API_URL_CATALOGO, urls.PUT_PRODUCTO_GENERICO_BOCETO_POSICION, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteProductosGenericosBocetos(id) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.PRODUCTO_GENERICO_BOCETO}/${id}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getProductosGenericosBocetosById(id) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.PRODUCTO_GENERICO_BOCETO}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Biblioteca de precios
export async function getBibPreciosFiltered(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.GET_BIBPRECIOS_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteBibPrecios(id) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_BIBPRECIOS_BY_ID}/${id}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateBibPrecios(payload) {
  return requests
    .putForm(constants.API_URL_CATALOGO, urls.UPDATE_BIBPRECIOS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertBibPrecios(payload) {
  return requests
    .postForm(constants.API_URL_CATALOGO, urls.INSERT_BIBPRECIOS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibPreciosById(id) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_BIBPRECIOS_BY_ID}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibPreciosExcelUrl() {
  return requests
    .get(constants.API_URL_CATALOGO, urls.GET_BIBPRECIOS_URL_EXCEL_FILE)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteBibPreciosCache() {
  return requests
    .remove(constants.API_URL_CATALOGO, 'BibliotecaPrecio/cache')
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function generateBibPreciosCache() {
  return requests
    .post(constants.API_URL_CATALOGO, 'BibliotecaPrecio/cache', {})
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Productos Desayuno
export async function getProductosDesayuno(categoria) {
  let url = urls.GET_PRODUCTOS_DESAYUNO
  if (categoria != null) url = `${url}?categoria=${categoria}`

  return requests.get(constants.API_URL_CATALOGO, url).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function getCategoriasProductosDesayuno() {
  return requests
    .get(constants.API_URL_CATALOGO, urls.GET_CATEGORIAS_PRODUCTOS_DESAYUNO)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateProductDesayuno(payload) {
  return requests
    .putForm(constants.API_URL_CATALOGO, urls.UPDATE_PRODUCTOS_DESAYUNO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Productos en Caja
export async function getProductosEnCaja(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.GET_PRODUCTOS_EN_CAJA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setProductosEnCaja(payload) {
  return requests
    .patch(constants.API_URL_CATALOGO, urls.PATCH_PRODUCTOS_EN_CAJA, payload)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

// Url Historial de ordenación de posiciones de productos
export async function getUrlHistorialPosiciones(categoriaId) {
  let url = urls.GET_URL_HISTORIAL_POSICIONES_BY_CATEGORIA
  if (categoriaId != null) url = `${url}?categoriaId=${categoriaId}`

  return requests.get(constants.API_URL_CATALOGO, url).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function setGuardarOrdenacionUrlProductos(payload) {
  return requests
    .patch(constants.API_URL_CATALOGO, urls.PATCH_URL_HISTORIAL_GUARDAR_POSICIONES, payload)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function setUrlHistorialPosiciones(payload) {
  return requests
    .post(constants.API_URL_CATALOGO, urls.POST_URL_HISTORIAL_POSICIONES, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteUrlHistorialPosiciones(id) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_URL_HISTORIAL_POSICIONES}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function generarFicherosSiteMap() {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_SHOPPING_AGGREGATOR_GENERAR_SITE_MAP_BACKGROUND)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Estado real de los ficheros en el blob del sitemap: nombre, tamaño y fecha de modificación. Sirve para
// comprobar lo que hay publicado ahora mismo, sin depender de lo que cuente la última generación.
export async function getFicherosSiteMap() {
  const response = await requests.get(
    constants.API_URL_AGGREGATOR,
    urls.GET_SHOPPING_AGGREGATOR_SITE_MAP_FICHEROS,
  )

  return { ok: response.ok, data: response.ok ? await response.json() : null }
}

// Contenido de uno de los ficheros del sitemap. Se pide al agregador y no al blob directamente porque el
// contenedor no tiene CORS, y así el visor puede pintar el texto tal cual, con sus etiquetas.
export async function getContenidoFicheroSiteMap(nombre) {
  const response = await requests.get(
    constants.API_URL_AGGREGATOR,
    `${urls.GET_SHOPPING_AGGREGATOR_SITE_MAP_FICHEROS}/${encodeURIComponent(nombre)}`,
  )

  return { ok: response.ok, data: response.ok ? await response.json() : null }
}

// Productos mas vendidos
export async function getProductosMasVendidos() {
  return requests
    .get(constants.API_URL_CATALOGO, urls.GET_PRODUCTOS_MAS_VENDIDOS)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setProductosMasVendidos(payload) {
  return requests
    .post(constants.API_URL_AGGREGATOR, urls.POST_PRODUCTOS_MAS_VENDIDOS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getProductosByIds(payload) {
  return requests
    .get(constants.API_URL_CATALOGO, `${urls.GET_PRODUCTOS_BY_ID}?${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteProductosMasVendidos(id) {
  return requests
    .remove(constants.API_URL_CATALOGO, `${urls.DELETE_PRODUCTOS_MAS_VENDIDOS}/${id}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateProductosMasVendidos(payload) {
  return requests
    .putForm(constants.API_URL_CATALOGO, urls.GET_PRODUCTOS_MAS_VENDIDOS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getTopVentas() {  
  return requests
    .get(constants.API_URL_CONFIG_PORTAL, urls.GET_TOP_VENTAS)
    .then(async response => {      
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateTopVentas(payload) {
  return requests
    .putForm(constants.API_URL_CONFIG_PORTAL, urls.GET_TOP_VENTAS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}